const OPENAI_API = 'https://openaitimesheet.azurewebsites.net/'
const ACS_API = 'https://app-prod-ashchatgpt.azurewebsites.net/'
const VERTEX_API = 'https://app-videosummerize-eastus.azurewebsites.net/'
const OPENAI_API_NEW = 'https://app-prod-ashchatgpt.azurewebsites.net/'
// const VERTEX_API = "http://127.0.0.1:5000/"
// const OPENAI_API_NEW = "http://127.0.0.1:5000/"
// const ACS_API = "http://127.0.0.1:5000/"
export const openaiEnv = {
    OPENAI_API: OPENAI_API,
    ACS_API: ACS_API,
    VERTEX_API:VERTEX_API,
    OPENAI_API_NEW : OPENAI_API_NEW
}